import type { ComponentRef, EditorSDK } from '@wix/editor-platform-sdk-types';
import {
  FormAppPreset,
  isPresetId,
  isTemplateId,
  type PresetId,
  templateIdToPresetId,
} from '../templates/templates';

export interface ComponentConfig {
  presetId?: PresetId;
  formId?: string;
}

export interface ReadConfigParams {
  sdk: EditorSDK;
  appToken: string;
  component: ComponentRef;
}

export const readConfig = async ({
  sdk,
  appToken,
  component,
}: ReadConfigParams): Promise<ComponentConfig> => {
  const configJson = (
    await sdk.document.components.serialize(appToken, {
      componentRef: component,
    })
  )?.data?.tpaData?.content;
  if (!configJson) {
    return {
      presetId: FormAppPreset.Blank,
    };
  }

  let parsedData;
  try {
    parsedData = JSON.parse(configJson);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Invalid JSON in component config', error);
    return {
      presetId: FormAppPreset.Blank,
    };
  }

  const rawPresetId = parsedData?.presetId;
  const rawFormId = parsedData?.formId;

  if (rawFormId) {
    if (isTemplateId(rawFormId)) {
      // Invalid config: formId is a templateId, lookup the preset
      return {
        presetId: templateIdToPresetId(rawFormId),
      };
    }
    // Form already exists
    return {
      presetId: isPresetId(rawPresetId) ? rawPresetId : FormAppPreset.Blank,
      formId: rawFormId,
    };
  }

  if (isTemplateId(rawPresetId)) {
    // Invalid config: presetId is a templateId, lookup the preset
    return {
      presetId: templateIdToPresetId(rawPresetId),
    };
  }

  return {
    presetId: isPresetId(rawPresetId) ? rawPresetId : FormAppPreset.Blank,
  };
};
